import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import TokenProvider from "../providers/TokenProvider";

export const apiSlice = createApi({
    reducerPath: "api",
    baseQuery: fetchBaseQuery({
        baseUrl: `https://${window.location.host}/api`,
        prepareHeaders: (headers) => {
            const token = TokenProvider.GetStoredToken();
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        }
    }),
    endpoints: () => ({})
});

export type IApiSlice = typeof apiSlice;
